import React from 'react'
import styles from  './home.module.css'
import Section from '../../Components/Section/Section'
import contactImage from '../../assets/contactImage.png'
import { LuMail, LuMapPin } from "react-icons/lu";
import { FaInstagram, FaTiktok } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen'
function ContactRow({ icon, label, text}) {
    return (
        <div className={styles.contactRow}>
            <div className={styles.contactIconContainer}>
                {icon}
            </div>
            <div className={styles.contactTextContainer}>
                <h2>{label}:</h2> 
                <p>{text}</p>
            </div>
        </div>
    )
}

function Contact() {
    const contactDetails = [
        { icon: <LuMail />, label: "Email", text: "astraea@nailsbyastraea.com" },
        { icon: <LuMapPin />, label: "Address", text: "18 Church Street, Alfred Station, NY 14803" }
    ]

    const socials = [
        { icon: <FaInstagram size={32} />, label: "Instagram", link: "https://www.instagram.com/nailsbyastraeaa/?hl=en" },
        { icon: <FaFacebookF size={32} />, label: "Facebook", link: "https://www.facebook.com/profile.php?id=61591361162707" },
        { icon: <FaTiktok size={32} />, label: "TikTok", link: "https://www.tiktok.com/@nailsbyastraeaa?lang=en" }
    ]

    const isSmallScreen = useIsSmallScreen();

    return (
        <Section id="contact" shrink={!isSmallScreen}>
            <div className={styles.contactContainer}>
                <div data-reveal className={styles.contactImageWrapper}>
                    <img src={contactImage} alt="Contact" />
                </div>
                <div className={styles.contactInnerContainer}>
                    <div data-reveal className={styles.homeHeaderContainer} style={{ textAlign: isSmallScreen ? 'center' : 'left' }}>
                        <h1 className={styles.smallHeader}>Contact Information</h1>
                        <h2 className={styles.largeHeader}>Let's stay in touch</h2>
                    </div>
                    <div data-reveal className={styles.contactInfo}>
                        {contactDetails.map((detail, index) => (
                            <ContactRow key={index} {...detail} />
                        ))}
                    </div>
                    <div data-reveal className={styles.actionRow}>
                        {socials.map((social, index) => (
                            <a key={index} href={social.link} target="_blank" rel="noopener noreferrer" aria-label={social.label} className={styles.socialLink}>
                                {social.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default Contact
